import { HttpInterceptorFn } from '@angular/common/http';
import { User } from '@gqlSchema';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  // TODO replace any with User type
  const currentUser: User = JSON.parse(localStorage.getItem("currentUser") || "null");
  let authToken = "AUTH_TOKEN_REQUIRED";

  if (currentUser && currentUser.authToken) {
    authToken = currentUser.authToken;
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authToken}`
    }
  });

  return next(authReq);
};
